module.exports = __webpack_public_path__ + "static/media/img-kid.2d10c7d1.png";